import React from "react";
import "./SettingsNewPasswordMainbox.css";

function PasswordMainbox() {
  return <div className="settingsnewpasswordmainbox"></div>;
}

export default PasswordMainbox;
